export default __webpack_public_path__ + "static/media/borderLight2Dark.2f915cf9.svg";